const routeSubpath = '/route'

export const routeRoutes = [
  {
    path: '/routes-and-timetables',
    name: 'Routes',
    meta: {
      showHeader: true,
      showFooter: true
    },
    component: () =>
      import(/* webpackChunkName: "Routes" */ '../views/routes/Routes.vue')
  },
  {
    path: `${routeSubpath}/:routeId/:routeName`,
    name: 'Route',
    props: true,
    meta: {
      showHeader: true,
      showFooter: true
    },
    component: () =>
      import(/* webpackChunkName: "Routes" */ '../views/routes/Route.vue')
  }
]
